/**
 * Thanh đo độ mạnh mật khẩu — FR-121, dùng cùng thuật toán với backend
 * (`apps/api/src/security/password.ts` passwordStrength).
 */

import { useT } from '../lib/i18n';

export function passwordStrength(password: string): number {
  let score = 0;
  if (password.length >= 12) score++;
  if (password.length >= 16) score++;
  if (/[A-Z]/.test(password) && /[a-z]/.test(password)) score++;
  if (/\d/.test(password) && /[^\p{L}\p{N}]/u.test(password)) score++;
  return Math.min(4, score);
}

export function PasswordStrength({ value }: { value: string }) {
  const t = useT();
  if (!value) return null;
  const score = passwordStrength(value);

  return (
    <div className="pw-strength">
      <div className="pw-bars" aria-hidden="true">
        {[0, 1, 2, 3].map((i) => (
          <i key={i} className={i < Math.max(1, score) ? `on-${score}` : ''} />
        ))}
      </div>
      <span className="hint">
        {t('password.strength')}: <b>{t(`password.strength.${score}`)}</b> · {t('password.hint')}
      </span>
    </div>
  );
}
